import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import rmService from "./rmService";

export const getUnlistedInventory = createAsyncThunk(
  "rm/getUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedInvestors = createAsyncThunk(
  "rm/getUnlistedInvestors",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getUnlistedInvestors(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedDPMaping = createAsyncThunk(
  "admin/unlisted/investor/getUnlistedTextDpid",
  async ( _,thunkAPI: any) => {
    try {
      const response = await rmService.getUnlistedDPMaping();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const addUnlistedInvestor = createAsyncThunk(
  "rm/addUnlistedInvestor",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.addUnlistedInvestor(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const addUnlistedOrder = createAsyncThunk(
  "rm/addUnlistedOrder",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.addUnlistedOrder(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedOrders = createAsyncThunk(
  "rm/getUnlistedOrders",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getUnlistedOrders(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const executeUnlistedOrder = createAsyncThunk(
  "rm/executeUnlistedOrder",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.executeUnlistedOrder(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedHoldings = createAsyncThunk(
  "rm/getUnlistedHoldings",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getUnlistedHoldings(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const uploadUnlistedInvestorDocs = createAsyncThunk(
  "rm/uploadUnlistedInvestorDocs",
  async (data: FormData, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.uploadUnlistedInvestorDocs(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedInvoice = createAsyncThunk(
  "rm/getUnlistedInvoice",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const resposne = await rmService.getInvoice(data);
      return resposne;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || {
          message:
            error.code === "ECONNABORTED"
              ? "Invoice generation timed out. Please check bank/IFSC details and try again."
              : error.message || "Failed to generate invoice.",
        }
      );
    }
  }
);

export const addBankDetails = createAsyncThunk(
  "rm/addBankDetails",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.addBankDetails(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getInvestorBanks = createAsyncThunk(
  "rm/getInvestorBanks",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getInvestorBanks(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const editOrder = createAsyncThunk(
  "rm/editOrder",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.editOrder(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getReport = createAsyncThunk(
  "rm/getReport",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await rmService.getReport(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  data: [],
  investors: [],
  orders: [],
  investorBanks: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  invoice: null,
};
export const rmSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getUnlistedInventory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch unlisted inventory";
      })
      .addCase(getUnlistedInvestors.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedInvestors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.investors = action.payload;
      })
      .addCase(getUnlistedInvestors.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch unlisted investors";
      })
      .addCase(addUnlistedInvestor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addUnlistedInvestor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(addUnlistedInvestor.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to add unlisted investor";
      })
      .addCase(getUnlistedDPMaping.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedDPMaping.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getUnlistedDPMaping.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch unlisted DP mapping";
      })
      .addCase(addUnlistedOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addUnlistedOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(addUnlistedOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to add unlisted order";
      })
      .addCase(getUnlistedOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload.data.data;
      })
      .addCase(getUnlistedOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch unlisted orders";
      })
      .addCase(executeUnlistedOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(executeUnlistedOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(executeUnlistedOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to execute unlisted order";
      })
      .addCase(uploadUnlistedInvestorDocs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadUnlistedInvestorDocs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(uploadUnlistedInvestorDocs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to upload unlisted investor docs";
      })
      .addCase(getUnlistedInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.invoice = action.payload;
      })
      .addCase(getUnlistedInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch unlisted invoice";
      })
      .addCase(addBankDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBankDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(addBankDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to add bank details";
      })
      .addCase(getInvestorBanks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvestorBanks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.investorBanks = action.payload;
      })
      .addCase(getInvestorBanks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to fetch investor banks";
      })
      .addCase(editOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(editOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to edit order";
      })
      .addCase(getReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(getReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = "Failed to get report";
      });
  },
});

export const { resetState } = rmSlice.actions;
export default rmSlice.reducer;
